export default __webpack_public_path__ + "locales/ro/People.json?hash=34073e7929c656153b7f5a069130c3ce";